import React from "react";

const MAP = {
  pronto: { cls: "badge-pronto", label: "Pronto alla Vendita" },
  criticita: { cls: "badge-criticita", label: "Pronto alla Vendita con Criticità Dichiarate" },
  non_conforme: { cls: "badge-non_conforme", label: "Non Conforme al Protocollo RX CASA" },
};

export default function EsitoBadge({ esito, testId }) {
  if (!esito) return <span data-testid={testId} className="badge-stamp text-[#5C5657] border-[#E6E4E0] bg-[#F4F3F1]">In attesa esito</span>;
  const m = MAP[esito] || MAP.pronto;
  return <span data-testid={testId} className={`badge-stamp ${m.cls}`}>{m.label}</span>;
}
